function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var PeerService = require('saito-js/lib/peer_service')["default"];

//
// Library
//
// the library  module is used to index content I have saved in my own transaction
// archives for curation, personal use and lending as legally permitted. It queries
// my peers for items they have indexed in the same collections, and fetches those
// records on load.
//
// the library abstracts away the storage and ownership of the content, assigning
// control across the distributed network to whichever publickey is in possession
// of the rights to use.
//
// this.collections = [
//   {
//     module 		: "Nwasm" ,
//     mod 		: this ,
//     collection 	: "Nwasm" ,
//     key 		: this.nwasm.random ,
//     shouldArchive 	: (tx) => { return false; } // true or false
//   }
// ]
//
// this.library[collection.id].peers{'publickey'} = [
//    {
//      id 		: "id" ,
//      title 		: "title" ,
//      description 	: "description" ,
//      num 		: 1 ,				// total in collection
//      available 	: 1 ,				// total available (not in use)
//      key 		: "" ,				// random key that encrypts content
//      checkout 	: [] ,
//      sig 		: "sig"				// sig of transaction with content
//   }
// ]
//
// The library module provides basic functionality for DRM-respecting management of this
// digital content. It specifically transfers ownership of the items in question when
// they are lent.
//
// Modules that wish to use the library to view/manage network-available content should
// respondTo() the "library-collection" event to inform the library of what kind of
// material it should track. The library will add this to its list of collections and
// start indexing and serving those materials to peers on request.
//
var Library = /*#__PURE__*/function (_ModTemplate) {
  function Library(app) {
    var _this;
    _classCallCheck(this, Library);
    _this = _callSuper(this, Library, [app]);
    _this.app = app;
    _this.name = 'Library';
    _this.slug = 'library';
    _this.description = 'Adds digital rights management (DRM) and curation and lending functionality, permitting users to create curated collections of content and share it in rights-permitting fashion.       ';
    _this.categories = 'Core Utilities DRM';
    _this.status = 'beta';
    _this["class"] = 'utility';

    //
    // any library borrowing coded for 2 hour minimum increments
    // TODO -- is this still used
    _this.return_milliseconds = 7200000;

    //
    // library['collection'].peers = {}
    //
    _this.library = {};

    //
    // the information stored will look like this
    //
    //
    _this.collections = [];

    //
    //
    //
    _this.load();

    //
    // index transactions that are saved
    //
    app.connection.on('saito-save-transaction', function (tx) {
      //      console.log("---------------------");
      //      console.log("---------------------");
      //      console.log("IN LIBRARY ON SAVE TX");
      //      console.log("---------------------");
      //      console.log("---------------------");

      //
      // fetch information for index
      //
      var txmsg = tx.returnMessage();
      var id = txmsg.id;
      var title = txmsg.title;
      var module = txmsg.module;
      var request = txmsg.request || '';
      var sig = tx.signature;

      //
      // sanity check to avoid adding duplicates
      //
      var does_item_exist_in_collection = _this.isItemInCollection({
        id: id
      }, module);
      if (does_item_exist_in_collection) {
        try {
          var c = confirm('Your library already contains a copy of this item. Is this a new copy?');
          if (!c) {
            alert('refusing to add duplicate item!');
          }
        } catch (err) {}
      }

      //
      // add item to library
      //
      for (var i = 0; i < _this.collections.length; i++) {
        if (_this.collections[i].shouldArchive(tx)) {
          var item = {
            id: id,
            title: txmsg.title,
            description: '',
            num: 1,
            // total
            available: 1,
            // total available
            checkout: [],
            sig: sig
          };
          _this.addItemToCollection(item, _this.collections[i], _this.publicKey);
          _this.save();
        }
      }
    });
    return _this;
  }

  //
  // initialization
  //
  // this asks any modules we have installed locally whether they want library
  // support. if they do, we run addCollection() to make sure that we will index
  // and fetch information needed.
  //
  _inherits(Library, _ModTemplate);
  return _createClass(Library, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _iterator, _step, m;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Library, "initialize", this, 3)([app]);
            case 1:
              _iterator = _createForOfIteratorHelper(app.modules.returnModulesRespondingTo('library-collection'));
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  m = _step.value;
                  this.addCollection(m.respondTo('library-collection'), this.publicKey);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (this.app.BROWSER == 0) {
        services.push(new PeerService(null, 'library', 'Library'));
      }
      return services;
    }

    //
    // ON PEER SERVICE UP
    //
    // when we connect to a peer that supports the "Library" service, we contact
    // them with a request for any information on collections we are interested in
    // accessing.
    //
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, peer) {
        var service,
          library_self,
          _iterator2,
          _step2,
          _loop,
          _args3 = arguments,
          _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              service = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              library_self = app.modules.returnModule('Library'); //
              // remote peer runs a library
              //
              if (!(service.service === 'library')) {
                _context3.n = 7;
                break;
              }
              //
              // fetch their library
              //
              _iterator2 = _createForOfIteratorHelper(library_self.collections);
              _context3.p = 1;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var m, message;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      m = _step2.value;
                      //
                      // we want to know what content is indexed for collection with specified name
                      //
                      message = {};
                      message.request = 'library collection';
                      message.data = {};
                      message.data.collection = m.name;

                      //
                      // add it to our library
                      //
                      app.network.sendRequestAsTransaction(message.request, message.data, function (res) {
                        if (res.length > 0) {
                          library_self.library[m.collection].peers[peer.publicKey] = res; // res = collection
                        }
                      }, peer.publicKey);
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              _iterator2.s();
            case 2:
              if ((_step2 = _iterator2.n()).done) {
                _context3.n = 4;
                break;
              }
              return _context3.d(_regeneratorValues(_loop()), 3);
            case 3:
              _context3.n = 2;
              break;
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
              _iterator2.e(_t);
            case 6:
              _context3.p = 6;
              _iterator2.f();
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee2, null, [[1, 5, 6, 7]]);
      }));
      function onPeerServiceUp(_x2, _x3) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() //
    // handle off-chain requests for copies of specific collections we may be
    // indexing.
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var tx,
          peer,
          mycallback,
          message,
          x,
          key,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              tx = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
              peer = _args4.length > 2 ? _args4[2] : undefined;
              mycallback = _args4.length > 3 ? _args4[3] : undefined;
              if (!(tx == null)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              message = tx.returnMessage(); //
              // respond to requests for our local collection
              //
              if (!(message.request === 'library collection')) {
                _context4.n = 6;
                break;
              }
              if (message.data) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              if (message.data.collection) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              if (this.library[message.data.collection].peers[this.publicKey]) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2);
            case 4:
              if (!mycallback) {
                _context4.n = 5;
                break;
              }
              x = JSON.parse(JSON.stringify(this.library[message.data.collection].peers[this.publicKey]));
              for (key in x) {
                x.random = '';
              } // do not share decryption key is all
              mycallback(this.library[message.data.collection].peers[this.publicKey]);
              return _context4.a(2, 1);
            case 5:
              return _context4.a(2);
            case 6:
              return _context4.a(2, _superPropGet(Library, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee3, this);
      }));
      function handlePeerTransaction(_x4) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() //
    // interacting with our collections
    //
    // - addCollection()
    // - isItemInCollection()
    // - addItemToCollection()
    // - checkoutItem()
    // - returnItem()
    //
  }, {
    key: "addCollection",
    value: function addCollection(collection) {
      var peer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'localhost';
      if (peer === 'localhost') {
        peer = this.publicKey;
      }
      if (this.collections[collection.name]) {
        if (this.app.BROWSER) {
          alert('collection already exists!');
        }
        return;
      }
      this.collections.push(collection);

      //
      // if this is an existing collection, we will already have content
      // indexed in our library. but if it is not indexed, we should create
      // the library and ensure we have "localhost" available as a peer
      // so there is a place to store our collection.
      //
      if (!this.library[collection.name]) {
        this.library[collection.name] = {};
        this.library[collection.name].peers = {};
        this.library[collection.name].peers[peer] = [];
      } else {
        if (!this.library[collection.name].peers) {
          this.library[collection.name].peers = {};
          this.library[collection.name].peers[peer] = [];
        }
      }
      this.save();
    }
  }, {
    key: "isItemInCollection",
    value: function isItemInCollection(item, collection) {
      var peer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'localhost';
      if (peer === 'localhost') {
        peer = this.publicKey;
      }
      if (this.library[collection]) {
        var idx = -1;
        var contains_item = false;
        for (var i = 0; i < this.library[collection].peers[this.publicKey].length; i++) {
          var _item = this.library[collection].peers[this.publicKey][i];
          if (_item.id == this.library[collection].peers[this.publicKey].id) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "addItemToCollection",
    value: function addItemToCollection(item, collection) {
      var peer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'localhost';
      if (peer === 'localhost') {
        peer = this.publicKey;
      }
      if (!this.library[collection.name]) {
        this.addCollection(collection);
      }

      //
      // the object inside the library looks like this
      //
      // id 		: "id" ,
      // title	: "title" ,
      // description 	: "description" ,
      // num 		: 1 ,				// total in collection
      // available 	: 1 ,				// total available (not in use)
      // random 	: "" ,				// random hash used to encrypt
      // checkout 	: [] ,
      // sig 		: "sig"

      var does_item_exist_in_collection = false;

      //
      // every item must have a unique signature
      //
      for (var i = 0; i < this.library[collection.name].peers[peer].length; i++) {
        if (this.library[collection.name].peers[peer][i].title === item.title && this.library[collection.name].peers[peer][i].sig == item.sig) {
          does_item_exist_in_collection = true;
        }
      }
      if (!does_item_exist_in_collection) {
        this.library[collection.name].peers[peer].push(item);
      }
    }
  }, {
    key: "returnItem",
    value: function returnItem(collection, publicKey, sig, mycallback) {
      //
      // get index of item
      //
      var idx = -1;
      for (var i = 0; i < this.library[collection].peers[this.publicKey].length; i++) {
        if (this.library[collection].peers[this.publicKey][i].sig === sig) {
          idx = i;
          break;
        }
      }
      if (idx != -1) {
        //
        // find the item
        //
        var item = this.library[collection].peers[publicKey][idx];

        //
        // is it checked out ?
        //
        var is_already_borrowed = 0;
        var is_already_borrowed_idx = -1;
        for (var _i = 0; _i < item.checkout.length; _i++) {
          if (item.checkout[_i].publicKey === publicKey) {
            item.checkout[_i].timestamp = new Date().getTime();
            is_already_borrowed_idx = _i;
          }
        }

        //
        // the one condition we permit re-borrowing is if this user is the
        // one who has borrowed the item previously and has it in their
        // possession. in that case they have simply rebooted their
        // machine and should be provided with the data under the previous
        // valid request to borrow, since they are already marked as in
        // control of the item.
        //
        // first we "unset" the loan so that it can be reset with the passing
        // through of control to the !is_already_borrowed sanity check.
        //
        if (is_already_borrowed) {
          for (var _i2 = 0; _i2 < item.checkout.length; _i2++) {
            if (item.checkout[_i2].publicKey === publicKey) {
              item.checkout.splice(_i2, 1);
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
              // be careful that item.available //
              // is not removed below for legal //
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
              item.available++;
              this.save();
              is_already_borrowed = 0;
            }
          }
        }
      }
    }
  }, {
    key: "checkoutItem",
    value: function checkoutItem(collection, publicKey, sig, mycallback) {
      //
      // if the collection doesn't exist, we cannot lend
      //
      if (!this.library[collection]) {
        return;
      }

      //
      // get index of item
      //
      var idx = -1;
      for (var i = 0; i < this.library[collection].peers[this.publicKey].length; i++) {
        if (this.library[collection].peers[this.publicKey][i].sig === sig) {
          idx = i;
          break;
        }
      }

      //
      // if the item exists
      //
      if (idx != -1) {
        //
        // grab the item
        //
        var item = this.library[collection].peers[publicKey][idx];

        //
        // is it checked out ?
        //
        var is_already_borrowed = 0;
        var is_already_borrowed_idx = -1;
        for (var _i3 = 0; _i3 < item.checkout.length; _i3++) {
          if (item.checkout[_i3].publicKey === publicKey) {
            item.checkout[_i3].timestamp = new Date().getTime();
            is_already_borrowed_idx = _i3;
          }
        }

        //
        // the one condition we permit re-borrowing is if this user is the
        // one who has borrowed the item previously and has it in their
        // possession. in that case they have simply rebooted their
        // machine and should be provided with the data under the previous
        // loan.
        //
        // this "unsets" the loan so that it can be reset with the passing
        // through of control to the !is_already_borrowed sanity check.
        //
        //
        if (is_already_borrowed) {
          for (var _i4 = 0; _i4 < item.checkout.length; _i4++) {
            if (item.checkout[_i4].publicKey === publicKey) {
              item.checkout.splice(_i4, 1);
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
              // be careful that item.available //
              // is not removed below for legal //
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
              item.available++;
              this.save();
              is_already_borrowed = 0;
            }
          }
        }

        //
        // now we can permit the checkout
        //
        if (!is_already_borrowed) {
          if (item.available < 1) {
            alert('1 - ' + item.available);
            this.app.storage.loadTransactions({
              sig: sig
            }, mycallback);
            return;
          }
          if (item.checkout.length > item.num) {
            alert('2 - ' + item.checkout.length + ' -- ' + item.num);
            this.app.storage.loadTransactions({
              sig: sig
            }, mycallback);
            return;
          }
          //
          // record the checkout
          //
          item.checkout.push({
            publicKey: publicKey,
            ts: new Date().getTime()
          });
          // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
          // be careful that item.available //
          // is not removed above for legal //
          // as allows sanity check         //
          // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
          item.available--;
          this.save();
          alert('ABOUT TO CHECKOUT!');
          this.app.storage.loadTransactions({
            sig: sig
          }, mycallback);
        }
      }
    }

    //
    // save and load
    //
  }, {
    key: "save",
    value: function save() {
      this.app.options.library = this.library;
      this.app.storage.saveOptions();
    }
  }, {
    key: "load",
    value: function load() {
      if (this.app.options.library) {
        this.library = this.app.options.library;
        return;
      }
      this.library = {};
      this.save();
    }
  }, {
    key: "createBorrowTransaction",
    value: function () {
      var _createBorrowTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
        var library_self, obj, key, newtx;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              library_self = this;
              obj = {
                module: 'Library',
                request: 'borrow',
                data: {
                  return_tx: library_self.createReturnTransaction(data)
                }
              };
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context5.n = 1;
              return library_self.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context5.v;
              newtx.msg = obj;
              _context5.n = 2;
              return newtx.sign();
            case 2:
              _context5.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context5.a(2, newtx);
          }
        }, _callee4, this);
      }));
      function createBorrowTransaction(_x5) {
        return _createBorrowTransaction.apply(this, arguments);
      }
      return createBorrowTransaction;
    }()
  }, {
    key: "createReturnTransaction",
    value: function () {
      var _createReturnTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
        var library_self, obj, key, newtx;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              library_self = this;
              obj = {
                module: 'Library',
                request: '',
                data: {}
              };
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context6.n = 1;
              return library_self.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context6.v;
              newtx.msg = obj;
              _context6.n = 2;
              return newtx.sign();
            case 2:
              _context6.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context6.a(2, newtx);
          }
        }, _callee5, this);
      }));
      function createReturnTransaction(_x6) {
        return _createReturnTransaction.apply(this, arguments);
      }
      return createReturnTransaction;
    }()
  }]);
}(ModTemplate);
module.exports = Library;